<div class="admin-modal">
  <!-- Header -->
  <div class="modal-header">
    <h3 class="modal-title">{{ title }}</h3>
    <div class="header-actions">
      <i class="fa"
         [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}"
         style="margin-right: 10px; cursor: pointer;"
         (click)="minimise = !minimise"></i>
      <i (click)="cancel()" class="fa fa-times" style="cursor: pointer;"></i>
    </div>
  </div>

  <!-- Body -->
  <div class="modal-body" [hidden]="minimise">
    <form #screenForm="ngForm" novalidate>

      @if (loading) {
<div class="formLoader">
        <i class="fa fa-spinner fa-spin fa-2x"></i>
      </div>
}

      <!-- Row: Screen Key, Version, Version Navigation -->
      @if (!loading && mode === 'edit' && screen_data?.screen_key) {
<div class="row top-row">
        <div class="col-md-2">
          <label>Screen Key:</label>
          <div class="btn btn-default read-only-field full-width">{{ screen_data.screen_key }}</div>
        </div>
        <div class="col-md-1">
          <label>Version:</label>
          <div class="btn btn-default read-only-field full-width">{{ screen_data.version_num }}</div>
        </div>
        <div class="col-md-3">
          <label>Versions</label>
          <div class="version-nav">
            <button type="button" class="btn btn-default btn-sm"
                    [disabled]="!canGoPrevious"
                    (click)="updateVersion(screen_data.version_num - 1)">
              <i class="fa fa-chevron-circle-left"></i> Previous
            </button>
            <button type="button" class="btn btn-default btn-sm"
                    [disabled]="!canGoNext"
                    (click)="updateVersion(screen_data.version_num + 1)">
              Next <i class="fa fa-chevron-circle-right"></i>
            </button>
          </div>
        </div>
        <div class="col-md-2">
          <label>Versions</label>
          <div class="btn btn-default read-only-field full-width">
            {{ screen_data.min_version_num || screen_data.version_num }} - {{ screen_data.max_version_num || screen_data.version_num }}
          </div>
        </div>
      </div>
}

      <!-- Row: Screen Name, Description, Status, Priority -->
      @if (!loading) {
<div class="row row-spaced">
        <div class="col-md-3">
          <label>Screen Name:</label>
          <input type="text" class="form-control" name="screen_name" required
                 #screenNameCtrl="ngModel"
                 placeholder="enter screen name"
                 [ngModel]="screen_data.screen_name"
                 (ngModelChange)="screen_data.screen_name=$event; createScreenLink($event)" />
          @if (screenNameCtrl.invalid && (screenNameCtrl.touched || submitted)) {
<span class="form-error-container"
               >Screen Name is required.</span>
}
        </div>
        <div class="col-md-5">
          <label>Screen Description:</label>
          <textarea class="form-control input-sm"
                    [(ngModel)]="screen_data.screen_desc" name="screen_desc"></textarea>
        </div>
        <div class="col-md-2">
          <label class="label-nowrap">Status: <i class="fa fa-info-circle" ap-tooltip [appendAfterTarget]="true" tooltipContent="Screen status" direction="top"></i></label>
          <select class="form-control" name="status" required
                  #statusCtrl="ngModel"
                  [(ngModel)]="screen_data.screen_status">
            @for (s of screenStatus; track $index) {
<option [value]="s.value">{{ s.name }}</option>
}
          </select>
          @if (statusCtrl.invalid && (statusCtrl.touched || submitted)) {
<span class="form-error-container"
               >Status is required.</span>
}
        </div>
        <div class="col-md-2">
          <label class="label-nowrap">Priority: <i class="fa fa-info-circle" ap-tooltip [appendAfterTarget]="true" tooltipContent="Screen display priority" direction="top"></i></label>
          <input type="number" class="form-control" name="screen_priority" required
                 #priorityCtrl="ngModel"
                 placeholder="enter priority"
                 [(ngModel)]="screen_data.screen_priority" />
          @if (priorityCtrl.invalid && (priorityCtrl.touched || submitted)) {
<span class="form-error-container"
               >Priority is required.</span>
}
        </div>
      </div>
}

      <!-- JCD Section (gray callout) -->
      @if (!loading) {
<div class="row row-spaced row-gray-callout">
        <div class="row" style="margin: 10px 5px 0 5px;">
          <div class="col-md-3">
            <label class="label-nowrap">Channel: <i class="fa fa-info-circle" ap-tooltip [appendAfterTarget]="true" tooltipContent="Select communication channel" direction="top"></i></label>
            <select class="form-control" name="channel" required
                    #channelCtrl="ngModel"
                    [(ngModel)]="jcdlist.channel.selected"
                    (ngModelChange)="onJcdSelectChange(3)">
              <option [ngValue]="null"></option>
              @for (s of jcdlist.channel?.list; track $index) {
<option [ngValue]="s">{{ s.name }}</option>
}
            </select>
            @if (channelCtrl.invalid && (channelCtrl.touched || submitted)) {
<span class="form-error-container"
                 >Channel is required.</span>
}
          </div>

          <div class="col-md-3">
            <label class="label-nowrap">Task: <i class="fa fa-info-circle" ap-tooltip [appendAfterTarget]="true" tooltipContent="Select applicable task" direction="top"></i></label>
            <select class="form-control" name="task" required
                    #taskCtrl="ngModel"
                    [disabled]="jcdlist.task?.disabled"
                    [(ngModel)]="jcdlist.task.selected"
                    (ngModelChange)="onJcdSelectChange(4)">
              <option [ngValue]="null"></option>
              @for (s of jcdlist.task?.taskList; track $index) {
<option [ngValue]="s.task_key">{{ s.indent }}{{ s.task_name }}</option>
}
            </select>
            @if (taskCtrl.invalid && (taskCtrl.touched || submitted)) {
<span class="form-error-container"
                 >Task is required.</span>
}
          </div>

          <div class="col-md-2">
            <label class="label-nowrap">Activity: <i class="fa fa-info-circle" ap-tooltip [appendAfterTarget]="true" tooltipContent="Select applicable activity" direction="top"></i></label>
            <select class="form-control" name="activity" required
                    #activityCtrl="ngModel"
                    [disabled]="jcdlist.activity?.disabled"
                    [(ngModel)]="jcdlist.activity.selected"
                    (ngModelChange)="onJcdSelectChange(5)">
              <option [ngValue]="null"></option>
              @for (s of jcdlist.activity?.list; track $index) {
<option [ngValue]="s">{{ s.name }}</option>
}
            </select>
            @if (activityCtrl.invalid && (activityCtrl.touched || submitted)) {
<span class="form-error-container"
                 >Activity is required.</span>
}
          </div>

          @if (screen_data.jcd_ta_key) {
<div class="col-md-1">
            <div class="jcd-badge">
              <i class="fa fa-check"></i> {{ screen_data.jcd_ta_key }}
            </div>
          </div>
}

          <div class="col-md-3">
            <label class="label-nowrap">Screen Role: <i class="fa fa-info-circle" ap-tooltip [appendAfterTarget]="true" tooltipContent="Role assigned to this screen" direction="top"></i></label>
            @if (roles.loading) {
<div><i class="fa fa-spinner fa-spin"></i></div>
}
            @if (!roles.loading) {

              <select class="form-control" name="roles" required
                      #rolesCtrl="ngModel"
                      [disabled]="roles.disabled"
                      [(ngModel)]="roles.selected">
                <option [ngValue]="null"></option>
                @for (r of roles.list; track $index) {
<option [ngValue]="r">{{ r.role_name }}</option>
}
              </select>
              @if (rolesCtrl.invalid && (rolesCtrl.touched || submitted)) {
<span class="form-error-container"
                   >Role is required.</span>
}
            
}
          </div>
        </div>
        <div class="row" style="margin: 10px 5px 5px 5px;"></div>
      </div>
}

      <!-- Row: Screen Link, Controller, Template -->
      @if (!loading) {
<div class="row row-spaced">
        <div class="col-md-3">
          <label class="label-nowrap">Screen Link: <i class="fa fa-info-circle" ap-tooltip [appendAfterTarget]="true" tooltipContent="URL-safe screen link identifier" direction="top"></i></label>
          <input type="text" class="form-control" name="screen_safe_link" required
                 #linkCtrl="ngModel"
                 placeholder="enter screen state"
                 [(ngModel)]="screen_data.screen_safe_link" />
          <span class="example">some-link-test</span>
          @if (linkCtrl.invalid && (linkCtrl.touched || submitted)) {
<span class="form-error-container"
               >Screen Link is required.</span>
}
        </div>
        <div class="col-md-3">
          <label class="label-nowrap">Screen Controller: <i class="fa fa-info-circle" ap-tooltip [appendAfterTarget]="true" tooltipContent="Angular controller name for this screen" direction="top"></i></label>
          <input type="text" class="form-control" name="screen_controller"
                 placeholder="enter screen controller name"
                 [(ngModel)]="screen_data.screen_controller"
                 [required]="screen_data.screen_type !== 'custom'" />
          <span class="example">GirdStandardController as ctrl</span>
        </div>
        <div class="col-md-6">
          <label class="label-nowrap">Screen Template: <i class="fa fa-info-circle" ap-tooltip [appendAfterTarget]="true" tooltipContent="Path to template HTML file" direction="top"></i></label>
          <input type="text" class="form-control" name="screen_template"
                 placeholder="enter path to template"
                 [(ngModel)]="screen_data.screen_template"
                 [required]="screen_data.screen_type !== 'custom'" />
          <span class="example">app/components/grid/grid-standard-tpl.html</span>
        </div>
      </div>
}

      <!-- Row: Screen Type, Action Key, Grid Key, SaveActionKey, Dashboard Id, API Calls -->
      @if (!loading) {
<div class="row row-spaced">
        <div class="col-md-2">
          <label class="label-nowrap">Screen Type: <i class="fa fa-info-circle" ap-tooltip [appendAfterTarget]="true" tooltipContent="Type of screen layout" direction="top"></i></label>
          <select class="form-control" name="screen_type" required
                  [(ngModel)]="screen_data.screen_type"
                  (ngModelChange)="generateApiKey()">
            @for (s of screen_type; track $index) {
<option [value]="s.value">{{ s.name }}</option>
}
          </select>
        </div>

        @if (showActionKey) {
<div class="col-md-1">
          <label class="label-nowrap">Action Key: <i class="fa fa-info-circle" ap-tooltip [appendAfterTarget]="true" tooltipContent="Action ID for data loading" direction="top"></i></label>
          <input type="text" class="form-control" name="action_key" required
                 #actionKeyCtrl="ngModel"
                 [(ngModel)]="screen_data.action_key"
                 (ngModelChange)="generateApiKey()" />
          @if (actionKeyCtrl.invalid && (actionKeyCtrl.touched || submitted)) {
<span class="form-error-container"
               >Action Key required.</span>
}
        </div>
}

        @if (showGridKey) {
<div class="col-md-1">
          <label class="label-nowrap">Grid Key: <i class="fa fa-info-circle" ap-tooltip [appendAfterTarget]="true" tooltipContent="Grid ID for grid rendering" direction="top"></i></label>
          <input type="text" class="form-control" name="grid_key" required
                 #gridKeyCtrl="ngModel"
                 [(ngModel)]="screen_data.grid_key"
                 (ngModelChange)="generateApiKey()" />
          @if (gridKeyCtrl.invalid && (gridKeyCtrl.touched || submitted)) {
<span class="form-error-container"
               >Grid Key required.</span>
}
        </div>
}

        @if (showSaveActionKey) {
<div class="col-md-1">
          <label>SaveActionKey:</label>
          <input type="text" class="form-control" name="batch_save_action_key" required
                 #saveAkCtrl="ngModel"
                 [(ngModel)]="screen_data.batch_save_action_key"
                 (ngModelChange)="generateApiKey()" />
          @if (saveAkCtrl.invalid && (saveAkCtrl.touched || submitted)) {
<span class="form-error-container"
               >Save action Key required.</span>
}
        </div>
}

        @if (showDashboardId) {
<div class="col-md-1">
          <label class="label-nowrap">Dashboard Id <i class="fa fa-info-circle" ap-tooltip [appendAfterTarget]="true" tooltipContent="Dashboard identifier" direction="top"></i></label>
          <input type="text" class="form-control" name="dashboard_id" required
                 #dashIdCtrl="ngModel"
                 [(ngModel)]="screen_data.dashboard_id"
                 (ngModelChange)="generateApiKey()" />
          @if (dashIdCtrl.invalid && (dashIdCtrl.touched || submitted)) {
<span class="form-error-container"
               >Dashboard Id required.</span>
}
        </div>
}

        @if (showApiCalls) {
<div [ngClass]="apiCallsColClass">
          <label class="label-nowrap">API Calls: <i class="fa fa-info-circle" ap-tooltip [appendAfterTarget]="true" tooltipContent="Auto-generated API endpoint configuration" direction="top"></i></label>
          <textarea class="form-control" name="api"
                    [(ngModel)]="screen_data.api" [disabled]="true"></textarea>
          <span class="example">{{"{"}}&#34;get&#34;:&#34;loadGridJson?action_id=1&grid_id=1&#34;{{"}"}} - copy from grid admin screen</span>
        </div>
}
      </div>
}

      <!-- Batch Process Settings (grid-import types) -->
      @if (!loading && isImportType) {
<div class="row row-spaced">
        <div class="col-md-12">
          <input type="checkbox" class="chk-box" [(ngModel)]="batch_settings" name="batch_settings_toggle"
                 (ngModelChange)="clearValues('all', batch_settings)">
          <span style="margin-left: 8px;">View Batch Processes Settings</span>
        </div>
      </div>
}
      @if (batch_settings) {
<div class="batch-settings-callout">
        <div class="row row-spaced">
          <div class="col-md-3 batch-section">
            <div class="col-md-12">
              <input type="checkbox" class="chk-box batch-chk" [(ngModel)]="screen_data.enable_fetch" name="enable_fetch"
                     [ngModelOptions]="{standalone: true}"
                     (ngModelChange)="clearValues('others', screen_data.enable_fetch)">
              <label>Enable Others Access:</label>
            </div>
            <div class="col-md-12" style="margin-top: 15px;">
              <label class="label-nowrap">Others Batch Process Access: <i class="fa fa-info-circle" ap-tooltip [appendAfterTarget]="true" tooltipContent="Role for others batch access" direction="top"></i></label>
              <select class="form-control" name="others_access"
                      [disabled]="!screen_data.enable_fetch"
                      [(ngModel)]="others_access"
                      [required]="screen_data.enable_fetch">
                <option [ngValue]="''"></option>
                @for (r of roles.list; track $index) {
<option [ngValue]="r">{{ r.role_name }}</option>
}
              </select>
            </div>
          </div>

          <div class="col-md-3 batch-section">
            <div class="col-md-12">
              <input type="checkbox" class="chk-box batch-chk" [(ngModel)]="screen_data.enable_reprocess" name="enable_reprocess"
                     [ngModelOptions]="{standalone: true}"
                     (ngModelChange)="clearValues('reprocess', screen_data.enable_reprocess)">
              <label>Enable Reprocess:</label>
            </div>
            <div class="col-md-12" style="margin-top: 15px;">
              <label class="label-nowrap">Allow Reprocess For: <i class="fa fa-info-circle" ap-tooltip [appendAfterTarget]="true" tooltipContent="Role allowed to reprocess" direction="top"></i></label>
              <select class="form-control" name="allow_reprocess"
                      [disabled]="!screen_data.enable_reprocess"
                      [(ngModel)]="allow_reprocess"
                      [required]="screen_data.enable_reprocess">
                <option [ngValue]="''"></option>
                @for (r of roles.list; track $index) {
<option [ngValue]="r">{{ r.role_name }}</option>
}
              </select>
            </div>
          </div>

          <div class="col-md-4">
            <div class="col-md-12">
              <input type="checkbox" class="chk-box batch-chk" [(ngModel)]="screen_data.enable_delete" name="enable_delete"
                     [ngModelOptions]="{standalone: true}"
                     (ngModelChange)="clearValues('delete', screen_data.enable_delete)">
              <label>Enable Delete Upload:</label>
            </div>
            <div class="col-md-8" style="margin-top: 15px;">
              <label class="label-nowrap">Delete Batch Upload: <i class="fa fa-info-circle" ap-tooltip [appendAfterTarget]="true" tooltipContent="Role allowed to delete uploads" direction="top"></i></label>
              <select class="form-control" name="delete_upload"
                      [disabled]="!screen_data.enable_delete"
                      [(ngModel)]="delete_upload"
                      [required]="screen_data.enable_delete">
                <option [ngValue]="''"></option>
                @for (r of roles.list; track $index) {
<option [ngValue]="r">{{ r.role_name }}</option>
}
              </select>
            </div>
            <div class="col-md-4" style="margin-top: 15px;">
              <label class="label-nowrap">DeleteActionKey: <i class="fa fa-info-circle" ap-tooltip [appendAfterTarget]="true" tooltipContent="Action key for delete operation" direction="top"></i></label>
              <input type="text" class="form-control" name="delete_action_key"
                     [disabled]="!screen_data.enable_delete"
                     [(ngModel)]="screen_data.delete_action_key"
                     [required]="screen_data.enable_delete" />
            </div>
          </div>
        </div>
      </div>
}

      <!-- Filter Section -->
      @if (!loading && showFilterSection) {
<div class="row row-spaced">
        <div class="col-md-2">
          <label class="label-nowrap">Filter Type: <i class="fa fa-info-circle" ap-tooltip [appendAfterTarget]="true" tooltipContent="Filter behavior type" direction="top"></i></label>
          <select class="form-control" name="filter_type" required
                  #filterTypeCtrl="ngModel"
                  [(ngModel)]="screen_data.filter_type">
            @for (f of filter_type; track $index) {
<option [value]="f.value">{{ f.name }}</option>
}
          </select>
          @if (filterTypeCtrl.invalid && (filterTypeCtrl.touched || submitted)) {
<span class="form-error-container"
               >Filter Type is required.</span>
}
        </div>

        <div class="col-md-3">
          <label class="label-nowrap">Filter Group: <i class="fa fa-info-circle" ap-tooltip [appendAfterTarget]="true" tooltipContent="Filter group configuration" direction="top"></i></label>
          <select class="form-control" name="filter_group_key"
                  [(ngModel)]="screen_data.filter_group_key">
            @for (g of filter_group; track $index) {
<option [value]="g.filter_group_key">{{ g.filter_group_name }}</option>
}
          </select>
        </div>

        <div class="filter-inherit-col">
          <label>Filter Inherit</label>
          <div class="radio-inline-group">
            <label class="radio-inline-label">
              <input type="radio" [(ngModel)]="screen_data.filter_inherit" name="filter_inherit" value="1"> Yes
            </label>
            <label class="radio-inline-label">
              <input type="radio" [(ngModel)]="screen_data.filter_inherit" name="filter_inherit" value="0"> No
            </label>
          </div>
        </div>

        <div class="col-md-3">
          <label class="label-nowrap">Split Param <i class="fa fa-info-circle" ap-tooltip [appendAfterTarget]="true" tooltipContent="Parameter for splitting API calls" direction="top"></i></label>
          <select class="form-control" name="split_call_param"
                  [(ngModel)]="screen_data.split_call_param">
            <option value=""></option>
            <option value="parent_me_string">Parent Me String</option>
          </select>
        </div>

        <div class="filter-chk-col">
          <label>Match Global Filters</label>
          <div><input type="checkbox" class="chk-box"
                 [ngModel]="screen_data.match_global_filter == 1"
                 (ngModelChange)="screen_data.match_global_filter = $event ? 1 : 0"
                 name="match_global_filter" /></div>
        </div>

        @if (showDisplayIssueColumns) {
<div class="filter-chk-col">
          <label>Display Issue Columns</label>
          <div><input type="checkbox" class="chk-box"
                 [ngModel]="screen_data.display_issue_columns == 1"
                 (ngModelChange)="screen_data.display_issue_columns = $event ? 1 : 0"
                 name="display_issue_columns" /></div>
        </div>
}
      </div>
}

      <!-- Tags, Category & Tax Type, Scenario Type -->
      @if (!loading) {
<div class="row row-spaced screen-level-tags">
        <!-- Tags Panel -->
        <div class="col-md-4">
          <div class="panel panel-default">
            <div class="panel-heading">
              <h4 style="margin: 0;">Tags:</h4>
            </div>
            <div class="panel-body" style="min-height: 220px;">
              <div class="tags-search-wrapper">
                <input type="text" class="form-control" [(ngModel)]="searchTagText" name="searchTagText"
                       (ngModelChange)="tagSearch($event)"
                       (focus)="tagDropdownOpen = true"
                       (blur)="closeTagDropdownDelayed()"
                       placeholder="Search/Add Tags..."
                       autocomplete="off" />
                <button class="btn btn-success btn-md" type="button"
                        (click)="addTags(searchTagText)"
                        [disabled]="!searchTagText || searchTagText.length <= 0 || tagBtnLoading"
                        style="margin-left: 10px;">
                  @if (tagBtnLoading) {
<span><i class="fa fa-spinner fa-pulse"></i></span>
}
                  Add
                </button>
              </div>
              @if (tagDropdownOpen && tagSearchResults.length > 0) {
<div class="search-menu">
                @for (tag of tagSearchResults; track $index) {
<div class="search-menu-item"
                     (mousedown)="selectTagItem(tag); $event.preventDefault()">
                  {{ tag.tag_name }}
                </div>
}
              </div>
}
              <div style="margin-top: 15px;">
                @for (tag of addedTags; track $index; let i = $index) {
<span class="added-tags">
                  {{ tag.tag_name }}
                  <i class="fa fa-times" (click)="deleteTags(i, tag)"></i>
                </span>
}
              </div>
            </div>
          </div>
        </div>

        <!-- Category & Tax Type Panel -->
        <div class="col-md-4">
          <div class="panel panel-default">
            <div class="panel-heading">
              <h4 style="margin: 0;">Category &amp; Tax Type:</h4>
            </div>
            <div class="panel-body" style="min-height: 220px;">
              <div class="multiselect-field">
                <label>Category</label>
                <ap-dropdown
                  [list]="dropdownLists.category"
                  [(ngModel)]="selectedCategories"
                  name="categorySelect"
                  [selectType]="'multiple'"
                  [enableNgContent]="false"
                  [optionName]="'label'"
                  [optionValue]="'value'"
                  [title]="'Category'"
                  [inputAriaLabel]="'Category'"
                  [hideTitleOnInput]="true"
                  [showSearchbox]="true"
                  [showSelectAll]="true"
                  [clearSearchKeyword]="true"
                  (onFilterResult)="onDropdownFilterResult('category', $event)">
                </ap-dropdown>
              </div>
              <div class="multiselect-field" style="margin-top: 15px;">
                <label>Tax type</label>
                <ap-dropdown
                  [list]="dropdownLists.taxType"
                  [(ngModel)]="selectedTaxTypes"
                  name="taxTypeSelect"
                  [selectType]="'multiple'"
                  [enableNgContent]="false"
                  [optionName]="'label'"
                  [optionValue]="'value'"
                  [title]="'Tax Type'"
                  [inputAriaLabel]="'Tax Type'"
                  [hideTitleOnInput]="true"
                  [showSearchbox]="true"
                  [showSelectAll]="true"
                  [clearSearchKeyword]="true"
                  (onFilterResult)="onDropdownFilterResult('taxType', $event)">
                </ap-dropdown>
              </div>
            </div>
          </div>
        </div>

        <!-- Scenario Type Panel -->
        <div class="col-md-4">
          <div class="panel panel-default">
            <div class="panel-heading">
              <h4 style="margin: 0;">Scenario Type: <i class="fa fa-info-circle" ap-tooltip [appendAfterTarget]="true" tooltipContent="Scenario types applicable to this screen" direction="top"></i></h4>
            </div>
            <div class="panel-body" style="min-height: 220px;">
              <div class="multiselect-field">
                <ap-dropdown
                  [list]="dropdownLists.scenario"
                  [(ngModel)]="selectedScenarioCodes"
                  name="scenarioTypeSelect"
                  [selectType]="'multiple'"
                  [enableNgContent]="false"
                  [optionName]="'scenario_type_desc'"
                  [optionValue]="'scenario_type_code'"
                  [title]="'Select scenario type'"
                  [inputAriaLabel]="'Scenario Type'"
                  [hideTitleOnInput]="true"
                  [showSearchbox]="true"
                  [showSelectAll]="true"
                  [clearSearchKeyword]="true"
                  (onFilterResult)="onDropdownFilterResult('scenario', $event)">
                </ap-dropdown>
              </div>
            </div>
          </div>
        </div>
      </div>
}

      <!-- Grid Import Settings (paste/upload/partial save) -->
      @if (!loading && isImportWithPaste) {
<div class="row row-spaced">
        <div class="col-md-2">
          <label>Enable Paste From xls:</label>
          <div><input type="checkbox" class="chk-box"
                 [ngModel]="screen_data.allow_paste_xls == 1"
                 (ngModelChange)="screen_data.allow_paste_xls = $event ? 1 : 0"
                 name="allow_paste_xls" /></div>
        </div>
        @if (screen_data.allow_paste_xls) {
<div class="col-md-2">
          <label>Max Rows Can Paste:</label>
          <input type="number" class="form-control"
                 [(ngModel)]="screen_data.max_paste_rows" name="max_paste_rows" />
        </div>
}
        <div class="col-md-2">
          <label>Enable Upload Template:</label>
          <div><input type="checkbox" class="chk-box"
                 [ngModel]="screen_data.allow_upload_xls == 1"
                 (ngModelChange)="screen_data.allow_upload_xls = $event ? 1 : 0"
                 name="allow_upload_xls" /></div>
        </div>
        <div class="col-md-2">
          <label>Enable Partial Save:</label>
          <div><input type="checkbox" class="chk-box"
                 [ngModel]="screen_data.allow_partial_save == 1"
                 (ngModelChange)="screen_data.allow_partial_save = $event ? 1 : 0"
                 name="allow_partial_save" /></div>
        </div>
      </div>
}

    </form>
  </div>

  <!-- Footer -->
  <div class="modal-footer" [hidden]="minimise">
    <button class="btn btn-info btn-sm" type="button" (click)="save()" [disabled]="crudLoading">
      @if (crudLoading) {
<span><i class="fa fa-spinner fa-pulse"></i></span>
} Save
    </button>
    <button class="btn btn-warning btn-sm" type="button" (click)="cancel()">Cancel</button>
  </div>
</div>
